<template>
    <div class="contact-form" v-loading="loading">
        <form v-if="!completed" @submit.prevent="submit">
            <div class="form-group">
                <label for="inputName">Nombre</label>
                <input type="text" class="form-control" :class="{'is-invalid': find(errors, {field: 'name'})}" id="inputName" v-model="input.name" required>
            </div>
            <div class="form-group">
                <label for="inputEmail">Correo</label>
                <input type="text" class="form-control" :class="{'is-invalid': find(errors, {field: 'email'})}" id="inputEmail" v-model="input.email" required>
            </div>
            <div class="form-group">
                <label>¿Que quieres hacer?</label>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="aportar-datos" id="defaultCheck1" v-model="input.subjects">
                    <label class="form-check-label" for="defaultCheck1">
                        Aportar datos
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="aportar-visualizaciones" id="defaultCheck2" v-model="input.subjects">
                    <label class="form-check-label" for="defaultCheck2">
                        Aportar visualizaciones
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="solicitar-nuevos-datos" id="defaultCheck3" v-model="input.subjects">
                    <label class="form-check-label" for="defaultCheck3">
                        Solicitar nuevos datos
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="solicitar-nuevas-visualizaciones" id="defaultCheck4" v-model="input.subjects">
                    <label class="form-check-label" for="defaultCheck4">
                        Solicitar nuevas visualizaciones
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="contar-como-estoy-utilizando-los-datos" id="defaultCheck6" v-model="input.subjects">
                    <label class="form-check-label" for="defaultCheck6">
                        Contar cómo estoy utilizando los datos
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="otro" id="defaultCheck5" v-model="input.subjects">
                    <label class="form-check-label" for="defaultCheck5">
                        Otro
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label for="inputMessage">Mensaje</label>
                <textarea name="" id="inputMessage" rows="10" class="form-control" :class="{'is-invalid': find(errors, {field: 'message'})}" v-model="input.message" required></textarea>
            </div>
            <div class="text-right">
                <button type="submit" class="btn btn-primary px-4">Enviar</button>
            </div>
        </form>
        <div v-else>
            <p>Gracias por ponerse en contacto con nosotros.</p>
        </div>
    </div>

</template>
<script>
    import axios from 'axios';
    import _ from 'lodash';
    export default{
        data: function(){
            return {
                input: {
                    name: '',
                    email: '',
                    subjects: [],
                    message: ''
                },
                errors: [],
                loading: false,
                completed: false
            }
        },
        methods:{
            find: _.find,
            submit: function(){
                this.loading = true;
                axios.post('/contact', this.input)
                    .then(response => {
                        this.loading = false;
                        this.completed = true;
                    })
                    .catch(error => {
                        //this.$set(this, 'errors', error.response.data);
                        this.loading = false;
                        this.errors = error.response.data;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Forms/Contact.vue